module.exports = __webpack_public_path__ + "img/UN.10bb56f5.png";